import { apiClient, type TruckTypeExEntity } from '@/libs/api'

export type FetchTruckTypeQuery = {
  tenantKey: string
  truckTypeId: number
}

export const fetchTruckType = async (
  { tenantKey, truckTypeId }: FetchTruckTypeQuery,
  signal?: AbortSignal
): Promise<TruckTypeExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .truck_types._id(truckTypeId)
    .$get({
      config: { signal }
    })
  return data
}
